<template>
  <div>
    <div class="question-overlay question-overlay--left">
      <img :src="`${assetPath}lockup-overlays/quiz_05-overlay--left@2x.png`" alt="">
    </div>
    <div class="accessible-text">
      <p>We Serve Coffee in the Following Areas:</p>
    </div>
    <transition name="fade">
      <div :class="{ 'question__container': true, 'transitioned-in': initialized }">
        <div class="svg-wrapper">
          <WeServe class="we-serve" />
        </div>
        <div class="svg-wrapper">
          <WeServeMobile class="we-serve--mobile" />
        </div>
        <form class="buttons buttons--multi-select" @change="checkThis(drinkIn)">
          <template v-for="(question, index) in questions">
            <div :key="index">
              <input type="checkbox" :id="question.id" name="drinkIn" :value="question.value" v-model="drinkIn" @click="check(isChecked(question.value), drinkIn)">
              <label :for="question.id"><span v-html="question.label"></span></label>
            </div>
          </template>
        </form>
        <div class="meta">
          <button v-if="formInteractedWith" @click="next()">Next</button>
          <p v-else>Select all that apply.</p>
        </div>
      </div>
    </transition>
    <div class="question-overlay question-overlay--right">
      <img :src="`${assetPath}lockup-overlays/quiz_05-overlay--right@2x.png`" alt="">
    </div>
    <div class="question-overlay question-overlay--bottom">
      <img :src="`${assetPath}lockup-overlays/quiz_05-overlay--bottom@2x.png`" alt="">
    </div>
  </div>
</template>

<script>
import { next } from './../../mixins/next.js'
import { assetPath } from './../../mixins/assetPath.js'
import WeServe from '@/assets/we-serve-coffee.svg'
import WeServeMobile from '@/assets/we-serve-coffee--mobile.svg'

export default {
  name: 'QCoffeeIn',
  components: {
    WeServe,
    WeServeMobile
  },
  props: {
    initialized: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      drinkIn: this.$store.state.quiz.in,
      questions: [
        {
          id: 'breakroom',
          value: 'breakroom',
          label: 'Breakroom'
        },
        {
          id: 'lobby',
          value: 'lobby',
          label: 'Lobby'
        },
        {
          id: 'meetings',
          value: 'meetings',
          label: 'Meetings &amp; Events'
        }
      ],
      formInteractedWith: false
    }
  },
  methods: {
    checkThis(drinkIn) {
      // console.log(drinkIn)
      this.formInteractedWith = true
      this.next('in', drinkIn, 'multi')
    },
    isChecked(value) {
      // console.log('drinkIn', this.drinkIn)
      if (this.drinkIn) {
        return this.drinkIn.indexOf(value) > 0 ? true : false
      }
    },
    check(isChecked, drinkIn) {
      if (isChecked) {
        this.formInteractedWith = true
        this.next('in', drinkIn, 'multi')
      }
    }
  },
  mixins: [next, assetPath]
}
</script>

<style lang="scss">

.we-serve {
  display: none;
  @include breakpoint(large) {
    display: block;
  }
}
.we-serve--mobile {
  display: block;
  @include breakpoint(large) {
    display: none;
  }
}

.question--question-five {
  // background-image: url($q5bgMobile);
  background-size: cover;
  width: 100%;
  .svg-wrapper {
    width: 89.868%;
    position: relative;
    top: -26vw;
  }
  .question-overlay--left {
    width: 33.65%;
  }
  .question-overlay--right {
    width: 34.958%;
    top: auto;
    bottom: 0;
  }
  @include breakpoint(large) {
    .svg-wrapper {
      width: 67.917%;
      top: 0;
      svg {
        height: 28vw; // for IE
      }
    }
    // background-image: url($q5bgDesktop);
  }
  .buttons {
    left: 0;
    right: 0;
    bottom: 31%;
    width: 89.868%;
    padding-right: 1%;
    margin: 0 auto;
    display: block; // kill flex
    div {
      // width: 33.333%;
      width: auto;
      // margin-right: -1px;
    }
    @include breakpoint(large) {
      bottom: 21%;
      width: 66%;
      padding-right: 1%;
      display: flex; // restore
      label {
        padding: 0.5em 1.5em;
      }
      div {
        width: 33.333%;
        margin-right: -3px;
      }
    }
  }
  .buttons--multi-select {
    text-align: left;
    label {
      position: relative;
      margin-bottom: -3px;
      & > span {
        display: block;
        position: relative;
        max-width: 36vw;
        margin: 0 auto;
        padding-left: 1em;
        &::before {
          content: '';
          display: block;
          position: absolute;
          width: 1.4em;
          height: 1.4em;
          border-radius: 0.7em;
          // position: absolute;
          left: -0.8em;
          top: -0.125em;
          background-color: white;
          border: 2px solid $green;
        }
      }
    }
    input:checked {
      & + label {
        background-color: $green;
        & > span {
          &::after {
            content: '';
            display: inline-block;
            width: 1.4em;
            height: 1.4em;
            // border-radius: 0.5em;
            left: -0.6em;
            top: 0.125em;
            position: absolute;
            background-image: svg-uri($check);
            background-size: 1em 1em;
            background-repeat: no-repeat;
          }
        }
      }
    }
  }
  .question__container {
    padding-bottom: 5%;
  }
}

.meta {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 14%;
  p {
    font-size: 14px;
    color: $text-light;
    margin: 0;
  }
  button {
    @include button-style;
    max-width: 180px;
  }
  @include breakpoint(large) {
    bottom: 12%;
    button {
      position: relative;
      top: 1vw;
    }
  }
}

</style>